module.exports = __webpack_public_path__ + "img/设备1web.a3def6bf.png";